// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filters-container {
  position: relative;
}
.filters-container .filters-button {
  background-color: #40A0C1;
  color: white;
  display: flex;
  align-items: center;
  border-radius: 50px;
  padding: 8px 12px;
  justify-content: space-between;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.filters-container .filters-floater-background {
  position: fixed;
  background-color: rgba(158, 158, 158, 0.3882352941);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
}
.filters-container .filters-floater {
  position: absolute;
  top: 0;
  left: 100px;
  background-color: white;
  width: 360px;
  min-height: 80px;
  height: -moz-fit-content;
  height: fit-content;
  max-height: 500px;
  z-index: 100;
  padding: 12px 20px;
  border-radius: 11px;
  border: 1px solid #D3E1ED;
  display: flex;
  flex-direction: column;
  overflow: visible;
}
.filters-container .filters-floater .filters-floater-footer {
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
}
.filters-container .filters-floater .filters-floater-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.filters-container .filters-floater .filters-floater-title-row .filters-floater-title-row-content {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 20px !important;
}
.filters-container .filters-floater .filters-floater-title-row .filters-floater-title-row-content .filters-floater-title {
  font-size: 18px;
  font-weight: bold;
  color: #142A31;
}
.filters-container .filters-floater .filters-floater-title-row .filters-floater-title-row-content .filters-floater-clear-all {
  font-size: 12px;
  color: #6A8991;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
  margin-bottom: 2px;
}
.filters-container .filters-floater .filters-floater-title-row .filters-floater-title-x-container {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.filters-container .filters-floater .filters-floater-add-filter {
  border: 1px solid #D3E1ED;
  border-radius: 20px;
  display: flex;
  color: white;
  align-items: center;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  height: 30px;
  width: -moz-fit-content;
  width: fit-content;
  background-color: #40A0C1;
  padding: 2px 15px;
  font-size: 14px;
}
.filters-container .filters-floater .filters-inner-floater {
  position: absolute;
  top: 100px;
  left: 30px;
  background-color: white;
  width: 360px;
  z-index: 99999999;
  padding: 15px 8px 8px 8px;
  border-radius: 11px;
  border: 1px solid #D3E1ED;
}
.filters-container .filters-floater .filters-inner-floater .filters-inner-floater-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 10px 10px 10px;
}
.filters-container .filters-floater .filters-inner-floater .filters-inner-floater-title-row .filters-inner-floater-title {
  font-size: 12px;
  color: #6A8991;
}
.filters-container .filters-floater .filters-inner-floater .filters-inner-floater-value {
  font-size: 14px;
  color: #365A64;
  margin: 0 0 5px 0;
  padding: 5px 10px 5px 10px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.filters-container .filters-floater .filters-inner-floater .filters-inner-floater-value:hover {
  background-color: #D3E1ED;
  border-radius: 5px;
}
.filters-container .filters-floater .filters-floater-selected-filter-container {
  border: 1px solid #D3E1ED;
  padding: 8px 15px;
  margin-bottom: 6px;
  border-radius: 30px;
  color: #365A64;
  -webkit-user-select: none;
          user-select: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.filters-container .filters-floater .filters-floater-selected-filter-container .filters-floater-selected-filter {
  width: 100%;
  margin-right: 20px;
  cursor: pointer;
}
.filters-container .filters-floater .filters-floater-selected-filter-container .filters-floater-selected-filter .filters-floater-selected-filter-title {
  font-size: 10px;
  color: #6A8991;
}
.filters-container .filters-floater .filters-floater-selected-filter-container .filters-floater-selected-filter .filters-floater-selected-filter-value {
  font-size: 14px;
  color: #365A64;
}
.filters-container .filters-floater .filters-floater-temp-filter-container {
  position: relative;
}
.filters-container .filters-floater .filters-floater-temp-filter-container .filters-floater-temp-filter-box {
  border: 1px solid #D3E1ED;
  padding: 8px 15px;
  margin: 10px 0;
  border-radius: 20px;
  color: #365A64;
  -webkit-user-select: none;
          user-select: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.filters-container .filters-floater .filters-floater-temp-filter-container .filters-floater-temp-filter-box .filters-floater-temp-filter-name {
  width: 100%;
  font-size: 14px;
  color: #365A64;
}
.filters-container .filters-floater .filters-floater-pick-value-container {
  position: absolute;
  top: 0;
  left: 380px;
  background-color: white;
  width: 300px;
  z-index: 99999999;
  padding: 15px;
  border-radius: 11px;
  border: 1px solid #D3E1ED;
}
.filters-container .filters-floater .filters-floater-pick-value-container .filters-floater-pick-value-search {
  width: 270px;
  padding: 10px;
  border: 1px solid gray;
  border-radius: 5px;
  margin-bottom: 10px;
  outline: none;
}
.filters-container .filters-floater .filters-floater-pick-value-container .filters-floater-pick-date-input {
  border: 1px solid #D3E1ED;
  margin: 5px 0;
  padding: 10px;
  width: 300px;
  box-sizing: border-box;
  border-radius: 5px;
  display: flex;
  color: #365A64;
  align-items: center;
}
.filters-container .filters-floater .filters-floater-pick-value-container .filters-floater-pick-date-input-disabled {
  border: 1px solid #D3E1ED;
  background-color: #eee;
  margin: 5px 0;
  padding: 10px;
  width: 300px;
  box-sizing: border-box;
  border-radius: 5px;
  display: flex;
  color: #555;
  outline: none;
  cursor: default;
  align-items: center;
}
.filters-container .filters-floater .filters-floater-pick-value-container .filters-floater-pick-value {
  padding: 5px;
  margin: 10px 0;
  color: #365A64;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  display: flex;
  align-items: center;
}
.filters-container .filters-floater .filters-floater-pick-value-container .filters-floater-pick-value:hover {
  background-color: #D3E1ED;
}
.filters-container .filters-floater .filters-floater-pick-value-container .filters-floater-pick-value-input-container {
  border: 1px solid #D3E1ED;
  margin: 10px 0;
  border-radius: 5px;
  display: flex;
  color: #365A64;
  align-items: center;
}
.filters-container .filters-floater .filters-floater-pick-value-container .filters-floater-pick-value-input-container .filters-floater-pick-value-input {
  background-color: transparent;
  border: 0;
  outline: 0;
  font-size: 14px;
  color: #6A8991;
  height: 30px;
}

/* New List Filter UI */
.filters-list-container {
  width: 325px !important;
  padding: 12px 12px 8px 12px !important;
}
.filters-list-container ::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px #fafafa;
  background-color: #fafafa;
}
.filters-list-container ::-webkit-scrollbar {
  width: 6px;
  background-color: #fafafa;
}
.filters-list-container ::-webkit-scrollbar-thumb {
  background-color: #c8c8c8;
  border-radius: 20px;
}

.filters-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.filters-list-title {
  font-size: 12px;
  font-weight: 600;
  color: #365A64;
}

.filters-text-input {
  border: 1px solid #D3E1ED;
  border-radius: 8px;
  padding: 8px 10px;
  margin: 6px 0 10px 0;
}

.filters-text-input-field {
  border: none;
  outline: none;
  width: 100%;
  font-size: 14px;
}

.filters-list-search {
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #D3E1ED;
  border-radius: 8px;
  padding: 8px 10px;
  margin: 6px 0 10px 0;
}

.filters-list-search-input {
  border: none;
  outline: none;
  width: 100%;
  font-size: 14px;
}

.filters-list-segment {
  display: flex;
  gap: 6px;
  margin: 8px 0 8px 0;
}

.filters-list-segment-txt {
  display: flex;
  gap: 6px;
  margin: 8px 0 8px 0;
  justify-content: space-between;
}

.filters-list-seg-btn {
  border: none;
  background: transparent;
  padding: 6px 15px;
  border-radius: 25px;
  cursor: pointer;
  color: #365A64;
  font-size: 12px;
}

.filters-list-seg-btn.active {
  background: #40A0C1;
  color: #fff;
}

.filters-list-options {
  max-height: 280px;
  overflow-y: auto;
  padding: 6px 0;
}

.filters-list-option {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px;
  border-radius: 5px;
  color: #365A64;
  cursor: pointer;
  margin-bottom: 3px;
}

.filters-list-option:hover {
  background: #EFF6FA;
}

.filters-list-option.selected {
  background: #7FAFBB;
  color: #fff;
}

.filters-list-option-label {
  font-size: 14px;
}

.filters-list-footer {
  display: flex;
  justify-content: flex-start;
  padding-top: 10px;
  border-top: 2px solid #D3E1ED;
  margin-top: 10px;
}

.filters-list-apply {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border: none;
  border-radius: 25px;
  background: #40A0C1;
  color: #fff;
  padding: 6px 15px;
  cursor: pointer;
  margin-bottom: 8px;
}

.filters-list-apply.disabled,
.filters-list-apply:disabled {
  background: #e6e6e6;
  color: #b4b4b4;
  cursor: not-allowed;
}

/* Numeric slider */
.filters-number-slider {
  padding: 8px 0 6px 0;
}

.filters-number-range {
  --primary: #40A0C1;
}

.filters-number-range .range-slider__range {
  background: #40A0C1;
  height: 6px;
}

.filters-number-range .range-slider__thumb {
  background: #40A0C1;
  box-shadow: 0 0 0 1px #40A0C1;
  width: 10px;
  height: 10px;
}

.filters-number-range .range-slider__thumb[data-lower] {
  z-index: 2;
}

.filters-number-range .range-slider__thumb[data-upper] {
  z-index: 3;
}

.filters-number-slider-labels {
  display: flex;
  justify-content: space-between;
  color: #6A8991;
  font-size: 12px;
  margin-top: 6px;
}

.filters-number-display {
  border: 1px solid #D3E1ED;
  border-radius: 8px;
  padding: 10px 14px;
  margin: 10px 0 8px 0;
  color: #365A64;
  font-weight: 600;
  font-size: 14px;
}

/* Date filter */
.filters-date-operator {
  margin-bottom: 8px;
}
.filters-date-operator .dropdown-container-square {
  width: 100% !important;
  color: #365A64;
}

.filters-date-calendar {
  background: #fff;
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  box-sizing: border-box;
  /* Reduce DayPicker footprint */
  --rdp-cell-size: 7px; /* tighter to ensure 7 columns fit */
  --rdp-caption-font-size: 8px;
  --rdp-accent-color: #40A0C1;
  --rdp-background-color: #EFF6FA;
  /* Constrain DayPicker to container width */
}
.filters-date-calendar .rdp {
  width: 100%;
  max-width: 100%;
}
.filters-date-calendar .rdp-months {
  display: block;
}
.filters-date-calendar .rdp-month {
  width: 100%;
  margin: 0;
}
.filters-date-calendar .rdp-table {
  width: 100%;
  table-layout: fixed;
}
.filters-date-calendar .rdp-month_grid {
  border: none;
}
.filters-date-calendar .rdp-week {
  border: none;
}
.filters-date-calendar .rdp-chevron {
  fill: #365A64 !important;
  width: 20px;
  height: 20px;
}
.filters-date-calendar .rdp-button_previous {
  width: 24px;
}
.filters-date-calendar .rdp-button_next {
  width: 24px;
}
.filters-date-calendar .rdp-caption_label {
  color: #365A64;
}
.filters-date-calendar .rdp-weekdays {
  border: none;
}
.filters-date-calendar .rdp-head_cell,
.filters-date-calendar .rdp-cell,
.filters-date-calendar .rdp-day {
  padding: 2px;
}
.filters-date-calendar .rdp-caption_label {
  font-size: 14px;
}
.filters-date-calendar .rdp-nav_button {
  width: 24px;
  height: 24px;
}
.filters-date-calendar .rdp-head_cell {
  font-size: 11px;
}
.filters-date-calendar .rdp-day_button {
  border-radius: 999px;
  color: #666666;
}
.filters-date-calendar .rdp-selected .rdp-day_button {
  background: #40A0C1;
  color: #fff;
  border: none;
  font-weight: 400;
  font-size: 16px;
}
.filters-date-calendar .rdp-chevron {
  fill: #365A64 !important;
  width: 16px;
  height: 16px;
}
.filters-date-calendar .rdp-button_previous {
  width: 20px;
}
.filters-date-calendar .rdp-button_next {
  width: 20px;
}

.filters-date-preset-hint {
  font-size: 12px;
  color: #6A8991;
  margin-top: 8px;
}

.filters-floater-title-x-container {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}`, "",{"version":3,"sources":["webpack://./src/components/Filters/Filters.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AACE;EACE,yBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,8BAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AACJ;AAEE;EACE,eAAA;EACA,mDAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;AAAJ;AAGE;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;AADJ;AAGI;EACE,aAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;AADN;AAII;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAFN;AAIM;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,oBAAA;AAFR;AAIQ;EACE,eAAA;EACA,iBAAA;EACA,cAAA;AAFV;AAKQ;EACE,eAAA;EACA,cAAA;EACA,yBAAA;UAAA,iBAAA;EACA,eAAA;EACA,kBAAA;AAHV;AAOM;EACE,eAAA;EACA,yBAAA;UAAA,iBAAA;AALR;AASI;EACE,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,YAAA;EACA,uBAAA;EAAA,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;AAPN;AAUI;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;AARN;AAUM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,2BAAA;AARR;AAUQ;EACE,eAAA;EACA,cAAA;AARV;AAaM;EACE,eAAA;EACA,cAAA;EACA,iBAAA;EACA,0BAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AAXR;AAaQ;EACE,yBAAA;EACA,kBAAA;AAXV;AAgBI;EACE,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;UAAA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAdN;AAgBM;EACE,WAAA;EACA,kBAAA;EACA,eAAA;AAdR;AAgBQ;EACE,eAAA;EACA,cAAA;AAdV;AAiBQ;EACE,eAAA;EACA,cAAA;AAfV;AAoBI;EACE,kBAAA;AAlBN;AAoBM;EACE,yBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;UAAA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAlBR;AAoBQ;EACE,WAAA;EACA,eAAA;EACA,cAAA;AAlBV;AAuBI;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AArBN;AAuBM;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;AArBR;AAwBM;EACE,yBAAA;EACA,aAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;AAtBR;AAyBM;EACE,yBAAA;EACA,sBAAA;EACA,aAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;AAvBR;AA0BM;EACE,YAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,aAAA;EACA,mBAAA;AAxBR;AA0BQ;EACE,yBAAA;AAxBV;AA4BM;EACE,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;AA1BR;AA4BQ;EACE,6BAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;AA1BV;;AAiCA,uBAAA;AACA;EACE,uBAAA;EACA,sCAAA;AA9BF;AAgCE;EAEE,yCAAA;EACA,yBAAA;AA/BJ;AAkCE;EAEE,UAAA;EACA,yBAAA;AAjCJ;AAoCE;EAEE,yBAAA;EACA,mBAAA;AAnCJ;;AAuCA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AApCF;;AAuCA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AApCF;;AAuCA;EACE,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;AApCF;;AAuCA;EACE,YAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;AApCF;;AAuCA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;AApCF;;AAuCA;EACE,YAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;AApCF;;AAuCA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AApCF;;AAuCA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,8BAAA;AApCF;;AAuCA;EACE,YAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AApCF;;AAuCA;EACE,mBAAA;EACA,WAAA;AApCF;;AAuCA;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;AApCF;;AAuCA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AApCF;;AAuCA;EACE,mBAAA;AApCF;;AAuCA;EACE,mBAAA;EACA,WAAA;AApCF;;AAuCA;EACE,eAAA;AApCF;;AAuCA;EACE,aAAA;EACA,2BAAA;EACA,iBAAA;EACA,6BAAA;EACA,gBAAA;AApCF;;AAuCA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AApCF;;AAuCA;;EAEE,mBAAA;EACA,cAAA;EACA,mBAAA;AApCF;;AAuCA,mBAAA;AACA;EACE,oBAAA;AApCF;;AAuCA;EAAwB,kBAAA;AAnCxB;;AAoCA;EAA6C,mBAAA;EAAqB,WAAA;AA/BlE;;AAgCA;EAA6C,mBAAA;EAAqB,6BAAA;EAA+B,WAAA;EAAa,YAAA;AAzB9G;;AA0BA;EAAyD,UAAA;AAtBzD;;AAuBA;EAAyD,UAAA;AAnBzD;;AAqBA;EACE,aAAA;EACA,8BAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AAlBF;;AAqBA;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAlBF;;AAqBA,gBAAA;AACA;EACE,kBAAA;AAlBF;AAoBE;EACE,sBAAA;EACA,cAAA;AAlBJ;;AAsBA;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EAEA,+BAAA;EACA,oBAAA,EAAA,oCAAA;EACA,4BAAA;EACA,2BAAA;EACA,+BAAA;EAEA,2CAAA;AArBF;AAsBE;EACE,WAAA;EACA,eAAA;AApBJ;AAsBE;EACE,cAAA;AApBJ;AAsBE;EACE,WAAA;EACA,SAAA;AApBJ;AAsBE;EACE,WAAA;EACA,mBAAA;AApBJ;AAuBE;EACE,YAAA;AArBJ;AAwBE;EACE,YAAA;AAtBJ;AAyBE;EACE,wBAAA;EACA,WAAA;EACA,YAAA;AAvBJ;AA0BE;EACE,WAAA;AAxBJ;AA2BE;EACE,WAAA;AAzBJ;AA4BE;EACE,cAAA;AA1BJ;AA6BE;EACE,YAAA;AA3BJ;AA8BE;;;EAEW,YAAA;AA3Bb;AA6BE;EAAqB,eAAA;AA1BvB;AA4BE;EAAkB,WAAA;EAAa,YAAA;AAxBjC;AA0BE;EAAiB,eAAA;AAvBnB;AAwBE;EAAkB,oBAAA;EAAsB,cAAA;AApB1C;AAsBE;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AApBJ;AAuBE;EACE,wBAAA;EACA,WAAA;EACA,YAAA;AArBJ;AAwBE;EACE,WAAA;AAtBJ;AAyBE;EACE,WAAA;AAvBJ;;AA2BA;EACE,eAAA;EACA,cAAA;EACA,eAAA;AAxBF;;AA2BA;EACE,eAAA;EACA,yBAAA;UAAA,iBAAA;AAxBF","sourcesContent":[".filters-container {\n  position: relative;\n\n  .filters-button {\n    background-color: #40A0C1;\n    color: white;\n    display: flex;\n    align-items: center;\n    border-radius: 50px;\n    padding: 8px 12px;\n    justify-content: space-between;\n    cursor: pointer;\n    user-select: none;\n  }\n\n  .filters-floater-background {\n    position: fixed;\n    background-color: #9e9e9e63;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 99;\n  }\n\n  .filters-floater {\n    position: absolute;\n    top: 0;\n    left: 100px;\n    background-color: white;\n    width: 360px;\n    min-height: 80px;\n    height: fit-content;\n    max-height: 500px;\n    z-index: 100;\n    padding: 12px 20px;\n    border-radius: 11px;\n    border: 1px solid #D3E1ED;\n    display: flex;\n    flex-direction: column;\n    overflow: visible;\n\n    .filters-floater-footer {\n      display: flex;\n      height: 100%;\n      width: 100%;\n      justify-content: center;\n      align-items: center;\n    }\n\n    .filters-floater-title-row {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      margin-bottom: 20px;\n\n      .filters-floater-title-row-content {\n        display: flex;\n        align-items: flex-end;\n        justify-content: space-between;\n        gap: 20px !important;\n\n        .filters-floater-title {\n          font-size: 18px;\n          font-weight: bold;\n          color: #142A31;\n        }\n\n        .filters-floater-clear-all {\n          font-size: 12px;\n          color: #6A8991;\n          user-select: none;\n          cursor: pointer;\n          margin-bottom: 2px;\n        }\n      }\n\n      .filters-floater-title-x-container {\n        cursor: pointer;\n        user-select: none;\n      }\n    }\n\n    .filters-floater-add-filter {\n      border: 1px solid #D3E1ED;\n      border-radius: 20px;\n      display: flex;\n      color: white;\n      align-items: center;\n      cursor: pointer;\n      user-select: none;\n      height: 30px;\n      width: fit-content;\n      background-color: #40A0C1;\n      padding: 2px 15px;\n      font-size: 14px;\n    }\n\n    .filters-inner-floater {\n      position: absolute;\n      top: 100px;\n      left: 30px;\n      background-color: white;\n      width: 360px;\n      z-index: 99999999;\n      padding: 15px 8px 8px 8px;\n      border-radius: 11px;\n      border: 1px solid #D3E1ED;\n\n      .filters-inner-floater-title-row {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding: 0px 10px 10px 10px;\n\n        .filters-inner-floater-title {\n          font-size: 12px;\n          color: #6A8991;\n        }\n\n      }\n\n      .filters-inner-floater-value {\n        font-size: 14px;\n        color: #365A64;\n        margin: 0 0 5px 0;\n        padding: 5px 10px 5px 10px;\n        cursor: pointer;\n        user-select: none;\n\n        &:hover {\n          background-color: #D3E1ED;\n          border-radius: 5px;\n        }\n      }\n    }\n\n    .filters-floater-selected-filter-container {\n      border: 1px solid #D3E1ED;\n      padding: 8px 15px;\n      margin-bottom: 6px;\n      border-radius: 30px;\n      color: #365A64;\n      user-select: none;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n\n      .filters-floater-selected-filter {\n        width: 100%;\n        margin-right: 20px;\n        cursor: pointer;\n\n        .filters-floater-selected-filter-title {\n          font-size: 10px;\n          color: #6A8991;\n        }\n\n        .filters-floater-selected-filter-value {\n          font-size: 14px;\n          color: #365A64;\n        }\n      }\n    }\n\n    .filters-floater-temp-filter-container {\n      position: relative;\n\n      .filters-floater-temp-filter-box {\n        border: 1px solid #D3E1ED;\n        padding: 8px 15px;\n        margin: 10px 0;\n        border-radius: 20px;\n        color: #365A64;\n        user-select: none;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n\n        .filters-floater-temp-filter-name {\n          width: 100%;\n          font-size: 14px;\n          color: #365A64;\n        }\n      }\n    }\n\n    .filters-floater-pick-value-container {\n      position: absolute;\n      top: 0;\n      left: 380px;\n      background-color: white;\n      width: 300px;\n      z-index: 99999999;\n      padding: 15px;\n      border-radius: 11px;\n      border: 1px solid #D3E1ED;\n\n      .filters-floater-pick-value-search {\n        width: 270px;\n        padding: 10px;\n        border: 1px solid gray;\n        border-radius: 5px;\n        margin-bottom: 10px;\n        outline: none;\n      }\n\n      .filters-floater-pick-date-input {\n        border: 1px solid #D3E1ED;\n        margin: 5px 0;\n        padding: 10px;\n        width: 300px;\n        box-sizing: border-box;\n        border-radius: 5px;\n        display: flex;\n        color: #365A64;\n        align-items: center;\n      }\n\n      .filters-floater-pick-date-input-disabled {\n        border: 1px solid #D3E1ED;\n        background-color: #eee;\n        margin: 5px 0;\n        padding: 10px;\n        width: 300px;\n        box-sizing: border-box;\n        border-radius: 5px;\n        display: flex;\n        color: #555;\n        outline: none;\n        cursor: default;\n        align-items: center;\n      }\n\n      .filters-floater-pick-value {\n        padding: 5px;\n        margin: 10px 0;\n        color: #365A64;\n        cursor: pointer;\n        user-select: none;\n        display: flex;\n        align-items: center;\n\n        &:hover {\n          background-color: #D3E1ED;\n        }\n      }\n\n      .filters-floater-pick-value-input-container {\n        border: 1px solid #D3E1ED;\n        margin: 10px 0;\n        border-radius: 5px;\n        display: flex;\n        color: #365A64;\n        align-items: center;\n\n        .filters-floater-pick-value-input {\n          background-color: transparent;\n          border: 0;\n          outline: 0;\n          font-size: 14px;\n          color: #6A8991;\n          height: 30px;\n        }\n      }\n    }\n  }\n}\n\n/* New List Filter UI */\n.filters-list-container {\n  width: 325px !important;\n  padding: 12px 12px 8px 12px !important;\n\n  ::-webkit-scrollbar-track\n  {\n    -webkit-box-shadow: inset 0 0 6px #fafafa;\n    background-color: #fafafa\n  }\n\n  ::-webkit-scrollbar\n  {\n    width: 6px;\n    background-color: #fafafa\n  }\n\n  ::-webkit-scrollbar-thumb\n  {\n    background-color: #c8c8c8;\n    border-radius: 20px;\n  }\n}\n\n.filters-list-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.filters-list-title {\n  font-size: 12px;\n  font-weight: 600;\n  color: #365A64;\n}\n\n.filters-text-input {\n  border: 1px solid #D3E1ED;\n  border-radius: 8px;\n  padding: 8px 10px;\n  margin: 6px 0 10px 0;\n}\n\n.filters-text-input-field {\n  border: none;\n  outline: none;\n  width: 100%;\n  font-size: 14px;\n}\n\n.filters-list-search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border: 1px solid #D3E1ED;\n  border-radius: 8px;\n  padding: 8px 10px;\n  margin: 6px 0 10px 0;\n}\n\n.filters-list-search-input {\n  border: none;\n  outline: none;\n  width: 100%;\n  font-size: 14px;\n}\n\n.filters-list-segment {\n  display: flex;\n  gap: 6px;\n  margin: 8px 0 8px 0;\n}\n\n.filters-list-segment-txt {\n  display: flex;\n  gap: 6px;\n  margin: 8px 0 8px 0;\n  justify-content: space-between;\n}\n\n.filters-list-seg-btn {\n  border: none;\n  background: transparent;\n  padding: 6px 15px;\n  border-radius: 25px;\n  cursor: pointer;\n  color: #365A64;\n  font-size: 12px;\n}\n\n.filters-list-seg-btn.active {\n  background: #40A0C1;\n  color: #fff;\n}\n\n.filters-list-options {\n  max-height: 280px;\n  overflow-y: auto;\n  padding: 6px 0;\n}\n\n.filters-list-option {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px;\n  border-radius: 5px;\n  color: #365A64;\n  cursor: pointer;\n  margin-bottom: 3px;\n}\n\n.filters-list-option:hover {\n  background: #EFF6FA;\n}\n\n.filters-list-option.selected {\n  background: #7FAFBB;\n  color: #fff;\n}\n\n.filters-list-option-label {\n  font-size: 14px;\n}\n\n.filters-list-footer {\n  display: flex;\n  justify-content: flex-start;\n  padding-top: 10px;\n  border-top: 2px solid #D3E1ED;\n  margin-top: 10px;\n}\n\n.filters-list-apply {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  border: none;\n  border-radius: 25px;\n  background: #40A0C1;\n  color: #fff;\n  padding: 6px 15px;\n  cursor: pointer;\n  margin-bottom: 8px;\n}\n\n.filters-list-apply.disabled,\n.filters-list-apply:disabled {\n  background: #e6e6e6;\n  color: #b4b4b4;\n  cursor: not-allowed;\n}\n\n/* Numeric slider */\n.filters-number-slider {\n  padding: 8px 0 6px 0;\n}\n\n.filters-number-range { --primary: #40A0C1; }\n.filters-number-range .range-slider__range { background: #40A0C1; height: 6px; }\n.filters-number-range .range-slider__thumb { background: #40A0C1; box-shadow: 0 0 0 1px #40A0C1; width: 10px; height: 10px; }\n.filters-number-range .range-slider__thumb[data-lower] { z-index: 2; }\n.filters-number-range .range-slider__thumb[data-upper] { z-index: 3; }\n\n.filters-number-slider-labels {\n  display: flex;\n  justify-content: space-between;\n  color: #6A8991;\n  font-size: 12px;\n  margin-top: 6px;\n}\n\n.filters-number-display {\n  border: 1px solid #D3E1ED;\n  border-radius: 8px;\n  padding: 10px 14px;\n  margin: 10px 0 8px 0;\n  color: #365A64;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n/* Date filter */\n.filters-date-operator {\n  margin-bottom: 8px;\n\n  .dropdown-container-square {\n    width: 100% !important;\n    color: #365A64;\n  }\n}\n\n.filters-date-calendar {\n  background: #fff;\n  width: 100%;\n  overflow-x: auto;\n  overflow-y: hidden;\n  box-sizing: border-box;\n\n  /* Reduce DayPicker footprint */\n  --rdp-cell-size: 7px; /* tighter to ensure 7 columns fit */\n  --rdp-caption-font-size: 8px;\n  --rdp-accent-color: #40A0C1;\n  --rdp-background-color: #EFF6FA;\n\n  /* Constrain DayPicker to container width */\n  .rdp {\n    width: 100%;\n    max-width: 100%;\n  }\n  .rdp-months {\n    display: block;\n  }\n  .rdp-month {\n    width: 100%;\n    margin: 0;\n  }\n  .rdp-table {\n    width: 100%;\n    table-layout: fixed;\n  }\n\n  .rdp-month_grid {\n    border: none;\n  }\n\n  .rdp-week {\n    border: none;\n  }\n\n  .rdp-chevron {\n    fill: #365A64!important;\n    width: 20px;\n    height: 20px;\n  }\n\n  .rdp-button_previous {\n    width: 24px;\n  }\n\n  .rdp-button_next {\n    width: 24px;\n  }\n\n  .rdp-caption_label {\n    color: #365A64;\n  }\n\n  .rdp-weekdays {\n    border: none;\n  }\n\n  .rdp-head_cell,\n  .rdp-cell,\n  .rdp-day { padding: 2px; }\n\n  .rdp-caption_label { font-size: 14px; }\n\n  .rdp-nav_button { width: 24px; height: 24px; }\n\n  .rdp-head_cell { font-size: 11px; }\n  .rdp-day_button { border-radius: 999px; color: #666666; }\n\n  .rdp-selected .rdp-day_button {\n    background: #40A0C1;\n    color: #fff;\n    border: none;\n    font-weight: 400;\n    font-size: 16px;\n  }\n\n  .rdp-chevron {\n    fill: #365A64 !important;\n    width: 16px;\n    height: 16px;\n  }\n\n  .rdp-button_previous {\n    width: 20px;\n  }\n\n  .rdp-button_next {\n    width: 20px;\n  }\n}\n\n.filters-date-preset-hint {\n  font-size: 12px;\n  color: #6A8991;\n  margin-top: 8px;\n}\n\n.filters-floater-title-x-container {\n  cursor: pointer;\n  user-select: none;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
